<app-dialog-base class="modalsendcommand" [Title]='"Send command to device"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()" [height]="'210px'">
  <div class="">
    <select id="commandtemplates" class="singleselect">
      <option value="-1" disabled selected style='display:none;'>{{ 'Select a command' | translate }}</option>
      <option value="0">{{ 'Write a command' | translate }}</option>
    </select>
    <input id="commandtext" type="text" placeholder="{{ 'Command text' | translate }}" />

    <input id="sendcommandtomultiple" type="checkbox"/>&nbsp;
    <label id="sendcommandtomultiplelabel" for="sendcommandtomultiple">{{ 'Send command to other %count selected devices' | translate }}</label>
  </div>
</app-dialog-base>
